module.exports = __webpack_public_path__ + "img/shop-bg-1.34f96c78.png";